import React, {useState} from "react"

import FieldsFactory from "../../../../../core/fields3/fields-factory"
import {FieldType} from "../../../../../core/fields3/field-type"
import FieldFormElementView from "../../../../../core/fields3/render/form-elemnent-view"
import {FieldViewSize} from "../../../../../core/fields3/const"
import AddView from "../submenu/add-view/add-view"
import ProjectSession from "../../../../../core/model2/project/project-session"
import {ViewType} from "../../../../../core/gd/const/views/view-type"

// const debug = "CompactViewSelector"
const debug = false

type Props = {
    project     : ProjectSession
}

export default function CompactViewSelector(props:Props) {

    const [key, setKey] = useState(gd.utils.guid())

    const onChangeView = (viewId:ID) => {
        gd.projectViews.get(viewId)?.open()
        setKey(gd.utils.guid()) // is required for FieldFormElementView to rerender with actual model value (for example if Link is selected)
    }

    // exclude request forms pinned to submenu
    const views = _.filter(gd.projectViews.models, (view)=>![ViewType.PROJECT_REQUEST_FORMS].includes(view.type))

    if (
        !gd.projectViews.currentView?.showInSubmenu
        || _.isEmpty(views)
    ) {

        if (
            !props.project.acl.canAddView
            || (
                props.project.isWorkspace
                && gd.projectViews.currentView.type !== ViewType.PROJECT_EVERYTHING // do not show add for workspace 'No Views'
            )
        ) {
            return null
        }

        return <AddView className="m-l-15" projectId={gd.projectViews.project.id}/>

    }

    const field = FieldsFactory.get({
        fieldId         : 'id',
        type            : FieldType.SELECT_VIEW,
        views           : views,
    })

    debug && console.log(debug, 'render', gd.projectViews.currentView)

    return (
        <FieldFormElementView key       = {key}
                              className = "m-l-15"
                              size      = {FieldViewSize.SMALL}
                              field     = {field}
                              options   = {{size: 28}}
                              model     = {gd.projectViews.currentView}
                              onChange  = {onChangeView}/>
    )
}